import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SearchBranch } from '../../../external/AggregationApi';
import { actions } from '../../modules/Actions';

export interface searchBranchStatusState {
  result: Array<SearchBranch>;
}

export const initialSearchBranchStatusState: searchBranchStatusState = { result: [] };

export const searchBranchStatusReducer = reducerWithInitialState(initialSearchBranchStatusState).case(
  actions.updateSearchBranch.status,
  (state: searchBranchStatusState, payload: searchBranchStatusState) => {
    return {
      ...state,
      ...payload,
    };
  }
);
